import { computed } from "vue";
import { createLockStore, createLockStoreComposable } from "JS/utilities/store";

const useGlobalLoaderLockStore = createLockStore("global-loader");

export function useGlobalLoader() {
	const store = useGlobalLoaderLockStore();
	const loading = computed(() => store.locked);

	/**
	 * Adds a child loading state to to the global loader and returns a writable boolean ref to update it.
	 *
	 * @param name name of the child loading state
	 * @param cleanup whether or not the child loading state should be cleared on unmount. defaults to `true`. note: will not be cleaned up when used outside of a component.
	 */
	function createChildLoader(name: string, cleanup = true) {
		return createLockStoreComposable(useGlobalLoaderLockStore)({ name, cleanup });
	}

	return {
		/**
		 * Readable ref; true when global loader has any active child loading state
		 */
		loading,
		createChildLoader,
	};
}